<div class="date-picker-container">
  <!-- Label -->
  @if (label) {
    <label for="datePickerInput" class="field-label" [class.required]="required">
      {{ label }}
    </label>
  }

  <!-- Input Field -->
  <div class="relative">
    <input
      id="datePickerInput"
      type="text"
      [value]="displayValue()"
      (click)="toggleCalendar()"
      readonly
      [placeholder]="placeholder"
      [disabled]="disabled"
      class="date-input"
      [class.error]="hasError"
    />
    <button type="button" (click)="toggleCalendar()" [disabled]="disabled" class="calendar-icon">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z"
        ></path>
      </svg>
    </button>
  </div>

  <!-- Error Message -->
  @if (errorMessage) {
    <div class="field-error">{{ errorMessage }}</div>
  }

  <!-- Calendar Dropdown -->
  @if (isCalendarOpen()) {
    <div class="calendar-dropdown" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <!-- Calendar Header -->
      <div class="calendar-header">
        <!-- Year Navigation -->
        <div class="year-navigation">
          @if (canNavigateToPreviousYear()) {
            <button type="button" (click)="previousYear()" class="nav-button" title="Previous Year">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
                ></path>
              </svg>
            </button>
          }

          <select [value]="currentYear()" (change)="selectYear(+$any($event.target).value)" class="year-select">
            @for (year of availableYears(); track year) {
              <option [value]="year" [selected]="year === currentYear()">{{ year }}</option>
            }
          </select>

          @if (canNavigateToNextYear()) {
            <button type="button" (click)="nextYear()" class="nav-button" title="Next Year">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 5l7 7-7 7M5 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          }
        </div>

        <!-- Month Navigation -->
        <div class="month-navigation">
          <button type="button" (click)="previousMonth()" class="nav-button">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>

          <div class="month-year">{{ currentMonth() }}</div>

          <button type="button" (click)="nextMonth()" class="nav-button">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Calendar Body -->
      <div class="calendar-body">
        <!-- Days of Week Header -->
        <div class="days-header">
          @for (day of daysOfWeek; track day) {
            <div class="day-label">{{ day }}</div>
          }
        </div>

        <!-- Calendar Grid -->
        <div class="calendar-grid">
          @for (week of calendarWeeks(); track week) {
            @for (day of week; track day.date) {
              <button
                type="button"
                (click)="selectDate(day)"
                [disabled]="day.isDisabled"
                [class]="getDayClasses(day)"
                class="calendar-day"
              >
                {{ day.day }}
              </button>
            }
          }
        </div>
      </div>
    </div>
  }
</div>

<!-- Click outside to close calendar -->
@if (isCalendarOpen()) {
  <div class="fixed inset-0 z-40" (click)="closeCalendar()" (keydown)="closeCalendar()"></div>
}
